// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"efe45d57","915":"a55797ee"}[chunkId] + ".chunk.js";
};